import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const T = {
  en: { title: "Install AVATAR 4 U", desc: "Get the robot on your home screen — instant match alerts, always logged in.", btn: "Install" },
  es: { title: "Instala AVATAR 4 U", desc: "Lleva el robot al escritorio de tu celular — alertas de match al instante, sesión siempre abierta.", btn: "Instalar" },
};

export const InstallPrompt = ({ lang }) => {
  const t = T[lang] || T.en;
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(localStorage.getItem("a4u_install_dismissed") === "1");

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  if (!deferred || dismissed) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice.catch(() => {});
    setDeferred(null);
  };
  const dismiss = () => { localStorage.setItem("a4u_install_dismissed", "1"); setDismissed(true); };

  return (
    <div className="fixed bottom-8 left-4 md:left-64 z-50 max-w-xs bg-[#0F0F1A] border border-[#00F5FF]/30 rounded-2xl p-4 shadow-[0_0_30px_rgba(0,245,255,0.2)] flex items-start gap-3" data-testid="install-prompt">
      <img src="/icons/icon-192.png" alt="AVATAR 4 U" className="w-11 h-11 rounded-xl shrink-0" />
      <div className="min-w-0">
        <p className="text-xs font-black text-white font-heading">{t.title}</p>
        <p className="text-[10px] text-white/50 mt-0.5 leading-snug">{t.desc}</p>
        <button data-testid="install-app-btn" onClick={install}
          className="mt-2 px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest bg-gradient-to-r from-[#B026FF] to-[#00F5FF] inline-flex items-center gap-1.5">
          <Download size={11} /> {t.btn}
        </button>
      </div>
      <button data-testid="install-dismiss-btn" onClick={dismiss} className="text-white/30 hover:text-white shrink-0"><X size={14} /></button>
    </div>
  );
};
